import request from '../utils/request';

// 获取用户列表
export const getUserList = (params) => {
  return request({
    url: '/api/manage/getUserList',
    method: 'get',
    params
  });
};

// 获取用户详情
export const getUserDetail = (id) => {
  return request({
    url: `/api/manage/users/${id}`,
    method: 'get'
  });
};

// 创建用户
export const createUser = (data) => {
  return request({
    url: '/api/manage/createAccount',
    method: 'post',
    data
  });
};

// 更新用户
export const updateUser = (data) => {
  return request({
    url: '/api/manage/updateUser',
    method: 'post',
    data  // data 包含 phone (必填), name (可选), password (可选)
  });
};

// 删除用户
export const deleteUser = (phone) => {
  return request({
    url: '/api/manage/deleteUser',
    method: 'post',
    data: { phone }
  });
};

